import { round } from '../units_helpers';
import type { SelectOptionPropsType } from '@Shelly/shelly-design-system/index';

export type ElevationUnit = 'm' | 'ft';

const M_TO_FT = 3.2808398950131;
const OPTIONS: ElevationUnit[] = ['m', 'ft'];

export const convertElevationFromM = (valueM: number, unit: ElevationUnit): number => {
	if (!Number.isFinite(valueM)) return NaN;
	return unit === 'ft' ? round(valueM * M_TO_FT, 2) : valueM;
};

export const convertElevationToM = (value: number, unit: ElevationUnit): number => {
	if (!Number.isFinite(value)) return NaN;
	return unit === 'ft' ? round(value / M_TO_FT, 2) : value;
};

export const elevationUnitLabel = (unit: ElevationUnit): string => {
	return unit === 'ft' ? 'ft' : 'm';
};

export const getElevationUnitOptions = (): SelectOptionPropsType[] => {
	return OPTIONS.map((u) => ({ title: elevationUnitLabel(u), value: u }));
};

export const convertElevation = (value: number, unit: ElevationUnit): string => {
	if (!Number.isFinite(value)) return '--';
	const elevation = convertElevationFromM(value, unit);
	return `${round(elevation)} ${unit}`;
};

/** Whole feet and remaining inches from a length in meters (for dual metric/imperial labels). */
export function metersToFeetInches(meters: number): { ft: number; inch: number } {
	if (!Number.isFinite(meters)) {
		return { ft: 0, inch: 0 };
	}
	const totalInches = meters / 0.0254;
	const ft = Math.floor(totalInches / 12);
	const inch = round(totalInches - ft * 12, 2);
	return { ft, inch };
}
